import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import { TrailerLocationContext } from '../utils/context';
import VerticalSpot from '../components/Lot/VerticalSpot';
import HorizontalSpot from '../components/Lot/HorizontalSpot';
import { Trailer, TrailerLocation } from '../types';
import AddModal from '../components/Modals/AddModal';
import EditModal from '../components/Modals/EditModal';
import TempModal from '../components/Modals/TempModal';
import LotMoveModal from '../components/Modals/LotMoveModal';
import Lot from '../components/Lot/Lot';

type Props = RouteComponentProps & {
	trailers: Trailer[];
};

const screenHeight = {
	height: 'calc(100vh - 5.75rem)',
};

export default function OffSiteLot({ path, trailers }: Props) {
	const [addOpen, setAddOpen] = useState(false);
	const [editOpen, setEditOpen] = useState(false);
	const [tempModal, setTempModal] = useState(false);
	const [lotModal, setLotModal] = useState(false);
	const [outModal, setOutModal] = useState(false);
	const [addIn, setAddIn] = useState(false);
	const [inModal, setInModal] = useState(false);
	const [spotClicked, setSpotClicked] = useState<any>(0);
	const [selctedTrailer, setSelectedTrailer] = useState<Trailer | null>(null);
	const [spots, setSpots] = useState<any>();

	const trailerLocations = useContext(TrailerLocationContext);
	const styles = {
		width: 200,
		height: 50,
		"font-family": "Helvetica Neue",
		"font-size": "30px",
		"font-weight": "bold",
		"color": "#777779"
	  };
	useEffect(() => {
		for (let i = 0; i < trailerLocations.length; i++) {
			if (trailerLocations[i].name === 'Off-Site Lot') {
				
				// const tempSpots: any[] = trailerLocations[i].Lot.Spots;
				
				const tempSpots: any[] = [...trailerLocations[i].Lot.Spots];
				const full = [...tempSpots.sort((a,b) => parseInt(a.name) - parseInt(b.name))];
								
				const th1 = tempSpots.splice(0, 50);
				const th2 = tempSpots.splice(0, 50);
				const th3 = tempSpots.splice(0, 20);


				setSpots({
					LotSpots: {
						full,
						th1,
						th2,
						th3,
					},
				});
			}
		}
	}, [trailerLocations]);

	if (spots && spots.LotSpots.th1.length > 0) {
		return (
			<div style={screenHeight} className="flex w-full overflow-y-auto">
				{addOpen ? (
					<AddModal
						open={addOpen}
						close={() => setAddOpen(false)}
						spotNumber={spotClicked}
						trailerLocation={TrailerLocation.OffSiteLot}
					/>
				) : null}
				{editOpen ? (
					<EditModal
						open={editOpen}
						close={() => setEditOpen(false)}
						trailer={selctedTrailer}
						trailerLocation={TrailerLocation.OffSiteLot}
					/>
				) : (
					<></>
				)}
				{tempModal ? (
					<TempModal
						open={tempModal}
						close={() => setTempModal(false)}
						trailer={selctedTrailer}
						trailerLocation={TrailerLocation.OffSiteLot}
						outRequest={false}
						editOpen={() => {
							setTempModal(false);
							setTimeout(() => {
								setEditOpen(true);
							}, 10);
						}}
						lotMove={() => {
							setTempModal(false);
							setTimeout(() => {
								setLotModal(true);
							}, 10);
						}}
						outModal={() => {
							setTempModal(false);
							setTimeout(() => {
								setOutModal(true);
							}, 10);
						}}
					/>
				) : null}
				{lotModal ? (
					<LotMoveModal
						open={lotModal}
						close={() => setLotModal(false)}
						spotNumber={spotClicked.name}
						trailer={selctedTrailer}
					/>
				) : null}

				<div className="hidden building:block w-full h-screen mt-5">
				<div className="flex justify-center"><h1 style={styles}>Off-Site Lot</h1></div>
					<div className=" flex flex-col justify-between w-full h-1/2">
						<div className=" w-full h-1/2 flex justify-center space-x-2">
							{spots.LotSpots.th1.map((i: any, k: any) => {
								return (
									<HorizontalSpot
										key={k}
										spot={i}
										trailers={trailers}
										lot={TrailerLocation.OffSiteLot}
										spotClicked={(spot) => setSpotClicked(spot)}
										trailerClicked={(trailerClicked) => setSelectedTrailer(trailerClicked)}
										addOpen={() => setAddOpen(true)}
										tempModal={() => setTempModal(true)}
									/>
								);
							})}
						</div>

						<div className=" w-full h-1/2 justify-center flex space-x-2">
							{spots.LotSpots.th2.map((i: any, k: any) => {
								return (
									<HorizontalSpot
										key={k}
										spot={i}
										trailers={trailers}
										lot={TrailerLocation.OffSiteLot}
										spotClicked={(spot) => setSpotClicked(spot)}
										trailerClicked={(trailerClicked) => setSelectedTrailer(trailerClicked)}
										addOpen={() => setAddOpen(true)}
										tempModal={() => setTempModal(true)}
									/>
								);
							})}
						</div>
						<div className=" w-full h-1/2 justify-center flex space-x-2">
							{spots.LotSpots.th3.map((i: any, k: any) => {
								return (
									<HorizontalSpot
										key={k}
										spot={i}
										trailers={trailers}
										lot={TrailerLocation.OffSiteLot}
										spotClicked={(spot) => setSpotClicked(spot)}
										trailerClicked={(trailerClicked) => setSelectedTrailer(trailerClicked)}
										addOpen={() => setAddOpen(true)}
										tempModal={() => setTempModal(true)}
									/>
								);
							})}
						</div>
					</div>
				</div>
				<div className="building:hidden w-full h-full mt-5 ">
					<h1 className="text-4xl font-bold">Off-Site Lot</h1>
					<div className="border-black border-t-2">
						<Lot
							spots={spots.LotSpots.full}
							lot={TrailerLocation.OffSiteLot}
							trailers={trailers}
							spotClicked={(spot) => setSpotClicked(spot)}
							trailerClicked={(trailer: Trailer) => {
								setSelectedTrailer(trailer);
							}}
							addOpen={() => {
								// setTrailerLocation(TrailerLocation.SECONDARY);
								setAddOpen(true);
							}}
							tempModal={() => {
								// setOutRequest(false);
								setTempModal(true);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}

	return <div className="flex justify-center items-center font-bold">Loading...</div>;
}
